/* eslint-disable sort-imports */
/* eslint-enable sort-imports: "error" */
// Imports should be alphabetized
import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
import apollo from '@/graphql'
import store from '@/store'
import * as log from 'loglevel'

import ChangeFrontendPage from '@/graphql/page/ChangeFrontendPage.gql'

import roleConstants from '../lib/roleConstants'

const AdvertiserCreation = () =>
  import(/* webpackChunkName: "AdvertiserCreation" */ '@/components/advertiser/AdvertiserCreation')
const AdvertiserDetails = () =>
  import(/* webpackChunkName: "AdvertiserDetails" */ '@/components/advertiser/AdvertiserDetails')
const AdvertiserList = () =>
  import(/* webpackChunkName: "AdvertiserList" */ '@/components/advertiser/AdvertiserList')
const BannerCreation = () =>
  import(/* webpackChunkName: "BannerCreation" */ '@/components/banner/BannerCreation')
const BannerDetails = () =>
  import(/* webpackChunkName: "BannerDetails" */ '@/components/banner/BannerDetails')
const BannerList = () =>
  import(/* webpackChunkName: "BannerList" */ '@/components/banner/BannerList')
const Debug = () => import(/* webpackChunkName: "Debug" */ '@/components/debug/Debug')
const IssueQueue = () =>
  import(/* webpackChunkName: "CallQueue" */ '@/components/device_issue/CallQueue')
const CampaignCreation = () =>
  import(/* webpackChunkName: "CampaignCreation" */ '@/components/campaign/CampaignCreation')
const CampaignManagement = () =>
  import(/* webpackChunkName: "CampaignManagement" */ '@/components/campaign2/CampaignManagement')
const CampaignDetails = () =>
  import(/* webpackChunkName: "CampaignDetails" */ '@/components/campaign/CampaignDetails')
const CampaignList = () =>
  import(/* webpackChunkName: "CampaignList" */ '@/components/campaign/CampaignList')
const CampaignReview = () =>
  import(/* webpackChunkName: "CampaignReview" */ '@/components/campaign/CampaignReview')
const Dashboard = () =>
  import(/* webpackChunkName: "Dashboard" */ '@/components/dashboard/Dashboard')
const DealCreation = () =>
  import(/* webpackChunkName: "DealCreation" */ '@/components/deal/DealCreation')
const DealDetails = () =>
  import(/* webpackChunkName: "DealDetails" */ '@/components/deal/DealDetails')
const DealSearch = () =>
  import(/* webpackChunkName: "DealSearch" */ '@/components/deal/DealSearch')
const DeviceDetails = () =>
  import(/* webpackChunkName: "DeviceDetails" */ '@/components/device/DeviceDetails')
const DeviceIssueCreation = () =>
  import(/* webpackChunkName: "DeviceIssueCreation" */ '@/components/device_issue/DeviceIssueCreation')
const DeviceIssueDetails = () =>
  import(/* webpackChunkName: "DeviceIssueDetails" */ '@/components/device_issue/DeviceIssueDetails')
const DeviceIssueList = () =>
  import(/* webpackChunkName: "DeviceIssueList" */ '@/components/device_issue/DeviceIssueList')
const DeviceList = () =>
  import(/* webpackChunkName: "DeviceList" */ '@/components/device/DeviceList')
const HotspotCreation = () =>
  import(/* webpackChunkName: "HotspotList" */ '@/components/hotspot/HotspotCreation')
const HotspotDetails = () =>
  import(/* webpackChunkName: "HotspotList" */ '@/components/hotspot/HotspotDetails')
const HotspotList = () =>
  import(/* webpackChunkName: "HotspotList" */ '@/components/hotspot/HotspotList')
const LastImpressionMetrics = () =>
  import(/* webpackChunkName: "LastImpressionMetrics" */ '@/components/metrics/LastImpressionMetrics')
const Login = () => import(/* webpackChunkName: "Login" */ '@/components/auth/Login')
const MarketingDashboard = () =>
  import(/* webpackChunkName: "MarketingDashboard" */ '@/components/marketing/MarketingDashboard')
const MarketingStoreList = () =>
  import(/* webpackChunkName: "MarketingStoreList" */ '@/components/marketing/MarketingStoreList')
const MultiFactorAuthenticationCheckpoint = () =>
  import(/* webpackChunkName: "MultiFactorAuthenticationCheckpoint" */ '@/components/auth/MultiFactorAuthenticationCheckpoint')
const MultiFactorAuthenticationEnroll = () =>
  import(/* webpackChunkName: "MultiFactorAuthenticationEnroll" */ '@/components/auth/MultiFactorAuthenticationEnroll')
const NotFound = () =>
  import(/* webpackChunkName: "NotFound" */ '@/components/common/NotFound')
const NotAuthorized = () =>
  import(/* webpackChunkName: "NotAuthorized" */ '@/components/common/NotAuthorized')
const PasswordReset = () =>
  import(/* webpackChunkName: "PasswordReset" */ '@/components/auth/PasswordReset')
const RetailerCreation = () =>
  import(/* webpackChunkName: "RetailerCreation" */ '@/components/retailer/RetailerCreation')
const RetailerDetails = () =>
  import(/* webpackChunkName: "RetailerDetails" */ '@/components/retailer/RetailerDetails')
const RetailerList = () =>
  import(/* webpackChunkName: "RetailerList" */ '@/components/retailer/RetailerList')
const SpringServeVideoList = () =>
  import(/* webpackChunkName: "SpringServeVideoList" */ '@/components/video/SpringServeVideoList')
const StoreCreation = () =>
  import(/* webpackChunkName: "StoreCreation" */ '@/components/store/StoreCreation')
const StoreDetails = () =>
  import(/* webpackChunkName: "StoreDetails" */ '@/components/store/StoreDetails')
const StoreList = () => import(/* webpackChunkName: "StoreList" */ '@/components/store/StoreList')
const StoreSearch = () =>
  import(/* webpackChunkName: "StoreSearch" */ '@/components/pricing/StoreSearch')
const UserCreation = () =>
  import(/* webpackChunkName: "UserCreation" */ '@/components/user/UserCreation')
const UserDetails = () =>
  import(/* webpackChunkName: "UserDetails" */ '@/components/user/UserDetails')
const UserList = () => import(/* webpackChunkName: "UserList" */ '@/components/user/UserList')
const UserSwitchInterstitial = () => import(/* webpackChunkName: "UserSwtichInterstitial" */ '@/components/user/UserSwitchInterstitial')
const VendorCreation = () =>
  import(/* webpackChunkName: "VendorCreation" */ '@/components/vendor/VendorCreation')
const VendorDetails = () =>
  import(/* webpackChunkName: "VendorDetails" */ '@/components/vendor/VendorDetails')
const VendorList = () =>
  import(/* webpackChunkName: "VendorList" */ '@/components/vendor/VendorList')
const VideoCreation = () =>
  import(/* webpackChunkName: "VideoCreation" */ '@/components/video/VideoCreation')
const VideoDetails = () =>
  import(/* webpackChunkName: "VideoDetails" */ '@/components/video/VideoDetails')
const VideoList = () => import(/* webpackChunkName: "VideoList" */ '@/components/video/VideoList')
const VideoReview = () =>
  import(/* webpackChunkName: "VideoReview" */ '@/components/video/VideoReview')
const WholesalerCreation = () =>
  import(/* webpackChunkName: "WholesalerCreation" */ '@/components/wholesaler/WholesalerCreation')
const WholesalerDetails = () =>
  import(/* webpackChunkName: "WholesalerDetails" */ '@/components/wholesaler/WholesalerDetails')
const WholesalerList = () =>
  import(/* webpackChunkName: "WholesalerList" */ '@/components/wholesaler/WholesalerList')

Vue.use(Router)

// TODO alphabetize routes by path rather than component (because order matters in this array)

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '*',
      redirect: '/not-found',
    },
    {
      component: AdvertiserCreation,
      name: 'AdvertiserCreation',
      path: '/advertiser/create',
      meta: {
        authRequired: true,
        pageName: 'Create Advertiser',
        layout: 'Sidebar',
      },
    },
    {
      component: AdvertiserDetails,
      name: 'AdvertiserDetails',
      path: '/advertiser/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Advertiser',
        layout: 'Sidebar',
      },
    },
    {
      component: AdvertiserList,
      name: 'AdvertiserList',
      path: '/advertisers',
      meta: {
        authRequired: true,
        pageName: 'Advertiser List',
        layout: 'Sidebar',
      },
    },
    {
      component: BannerCreation,
      name: 'BannerCreation',
      path: '/banner/create',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:banners',
        pageName: 'Create Banner',
        layout: 'Sidebar',
      },
    },
    {
      component: BannerDetails,
      name: 'BannerDetails',
      path: '/banner/:id',
      props: true,
      meta: {
        authRequired: true,
        requiredPermission: 'feature:banners',
        pageName: 'Banner',
        layout: 'Sidebar',
      },
    },
    {
      component: BannerList,
      name: 'BannerList',
      path: '/banners',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:banners',
        pageName: 'Banner List',
        layout: 'Sidebar',
      },
    },
    {
      component: IssueQueue,
      name: 'IssueQueue',
      path: '/issue-queue',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:callQueue',
        pageName: 'Issue Queue',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignCreation,
      name: 'CampaignCreation',
      path: '/campaign/create',
      meta: {
        authRequired: true,
        pageName: 'Create Campaign',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignManagement,
      name: 'CampaignManagement',
      path: '/campaign/:id/manage',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Create Management',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignDetails,
      name: 'CampaignDetails',
      path: '/campaign/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Campaign',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignList,
      name: 'CampaignList',
      path: '/campaigns',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:campaigns',
        pageName: 'Campaign List',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignReview,
      name: 'CampaignReview',
      path: '/review/campaign',
      meta: {
        authRequired: true,
        pageName: 'Review Campaigns',
        layout: 'Sidebar',
      },
    },
    {
      component: Dashboard,
      name: 'Dashboard',
      path: '/',
      meta: {
        authRequired: true,
        pageName: 'Dashboard',
        layout: 'Sidebar',
      },
    },
    {
      component: DealCreation,
      name: 'DealCreation',
      path: '/deals/create',
      meta: {
        authRequired: true,
        pageName: 'Create Deal',
        layout: 'Sidebar',
      },
    },
    {
      component: DealDetails,
      name: 'DealDetails',
      path: '/deals/:id/',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Deal',
        layout: 'Sidebar',
      },
    },
    {
      component: DealSearch,
      name: 'DealSearch',
      path: '/deals',
      meta: {
        authRequired: true,
        pageName: 'Deal Search',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceDetails,
      name: 'DeviceDetails',
      path: '/device/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Device',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceIssueCreation,
      name: 'DeviceIssueCreation',
      path: '/device-issue/create',
      meta: {
        authRequired: true,
        pageName: 'Create Device Issue',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceIssueDetails,
      name: 'DeviceIssueDetails',
      path: '/device-issue/:id',
      props: true,
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:issue',
        pageName: 'Device Issue',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceIssueList,
      name: 'DeviceIssueList',
      path: '/device-issues',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:issues',
        pageName: 'Device Issue List',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceList,
      name: 'DeviceList',
      path: '/devices',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:devices',
        pageName: 'Device List',
        layout: 'Sidebar',
      },
    },
    {
      component: HotspotCreation,
      name: 'HotspotCreation',
      path: '/hotspot/create',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Create Hotspot',
        layout: 'Sidebar',
      },
    },
    {
      component: HotspotDetails,
      name: 'HotspotDetails',
      path: '/hotspot/:id?',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Hotspot',
        layout: 'Sidebar',
      },
    },
    {
      component: HotspotList,
      name: 'HotspotList',
      path: '/hotspots',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Hotspot List',
        layout: 'Sidebar',
      },
    },
    {
      component: LastImpressionMetrics,
      name: 'LastImpressionMetrics',
      path: '/metrics/advertising',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:advertising:metrics',
        layout: 'Sidebar',
      },
    },
    {
      component: Login,
      name: 'Login',
      path: '/login',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: MarketingDashboard,
      name: 'Marketing',
      path: '/marketing',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:dashboard',
        pageName: 'Marketing Dashboard',
        layout: 'Sidebar',
      },
    },
    {
      component: MarketingStoreList,
      name: 'MarketingStoreList',
      path: '/marketing/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:stores',
        pageName: 'Marketing Store List',
        layout: 'Sidebar',
      },
    },
    {
      component: MultiFactorAuthenticationEnroll,
      name: 'MultiFactorAuthenticationEnroll',
      path: '/mfa/enroll',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: MultiFactorAuthenticationCheckpoint,
      name: 'MultiFactorAuthenticationCheckpoint',
      path: '/mfa/checkpoint',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: NotFound,
      name: 'NotFound',
      path: '/not-found',
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: NotAuthorized,
      name: 'NotAuthorized',
      path: '/not-authorized',
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: PasswordReset,
      name: 'PasswordReset',
      path: '/reset',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: CampaignList,
      name: 'PromotionList',
      path: '/promotions',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:campaigns',
        pageName: 'Promotion List',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignDetails,
      name: 'PromotionDetails',
      path: '/promotion/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: RetailerCreation,
      name: 'RetailerCreation',
      path: '/retailer/create',
      meta: {
        authRequired: true,
        pageName: 'Create Retailer',
        layout: 'Sidebar',
      },
    },
    {
      component: RetailerDetails,
      name: 'RetailerDetails',
      path: '/retailer/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: RetailerList,
      name: 'RetailerList',
      path: '/retailers',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:retailers',
        pageName: 'Retailer List',
        layout: 'Sidebar',
      },
    },
    {
      component: SpringServeVideoList,
      name: 'SpringServeVideoList',
      path: '/video/springservevideos',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:springserve',
        pageName: 'SpringServe Video List',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreCreation,
      name: 'StoreCreation',
      path: '/store/create',
      meta: {
        authRequired: true,
        pageName: 'Create Store',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreDetails,
      name: 'StoreDetails',
      path: '/store/:id/:view?',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Store',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreList,
      name: 'StoreList',
      path: '/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stores:stores',
        pageName: 'Store List',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreSearch,
      name: 'StoreSearch',
      path: '/pricing/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:pricing:store_search',
        pageName: 'Store Search',
        layout: 'Sidebar',
      },
    },
    {
      component: UserCreation,
      name: 'UserCreation',
      path: '/user/create',
      meta: {
        authRequired: true,
        pageName: 'Create User',
        layout: 'Sidebar',
      },
    },
    {
      component: UserDetails,
      name: 'UserDetails',
      path: '/user/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'User',
        layout: 'Sidebar',
      },
    },
    {
      component: UserList,
      name: 'UserList',
      path: '/users',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:users:users',
        pageName: 'User List',
        layout: 'Sidebar',
      },
    },
    {
      component: UserSwitchInterstitial,
      name: 'UserSwitchInterstitial',
      path: '/switch',
      meta: {
        authRequired: true,
        layout: 'Empty',
      },
    },
    {
      component: VendorCreation,
      name: 'VendorCreation',
      path: '/vendor/create',
      meta: {
        authRequired: true,
        pageName: 'Create Vendor',
        layout: 'Sidebar',
      },
    },
    {
      component: VendorDetails,
      name: 'VendorDetails',
      path: '/vendor/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: VendorList,
      name: 'VendorList',
      path: '/vendors',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:products:vendors',
        pageName: 'Vendor List',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoCreation,
      name: 'VideoCreation',
      path: '/video/create',
      meta: {
        authRequired: true,
        pageName: 'Create Video',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoDetails,
      name: 'VideoDetails',
      path: '/video/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Video',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoList,
      name: 'VideoList',
      path: '/videos',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:videos',
        pageName: 'Video List',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoReview,
      name: 'VideoReview',
      path: '/review/video',
      meta: {
        authRequired: true,
        pageName: 'Review Videos',
        layout: 'Sidebar',
      },
    },
    {
      component: WholesalerCreation,
      name: 'WholesalerCreation',
      path: '/wholesaler/create',
      meta: {
        authRequired: true,
        pageName: 'Create Wholesaler',
        layout: 'Sidebar',
      },
    },
    {
      component: WholesalerDetails,
      name: 'WholesalerDetails',
      path: '/wholesaler/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: WholesalerList,
      name: 'WholesalerList',
      path: '/wholesalers',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stores:wholesalers',
        pageName: 'Wholesaler List',
        layout: 'Sidebar',
      },
    },
    {
      component: Debug,
      name: 'Debug',
      path: '/debug',
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
  ],
})

router.afterEach((to, from) => {
  if (store.getters['Auth/authenticated']) {
    // Run after DOM updates and component queries
    Vue.nextTick(() => {
      setTimeout(() => {
        apollo.defaultClient.mutate({
          mutation: ChangeFrontendPage,
          variables: {
            pageChange: {
              newPage: to.path,
              oldPage: from.path,
            },
          },
        })
      }, 1500)
    })
  }
})

router.beforeEach((to, from, next) => {
  /**
   * Important Note:
   *
   * Since router includes store, it's adviseable
   * to avoid importing router in any modules to use
   * for common redirects. A circular import could cause
   * store to be undefined, causing the router guard to
   * fail and the application to stop loading completely.
   */

  // Check validity of authentication session, remove if expired
  store.dispatch('Auth/checkExpiration').then(() => {
    // Prevent MFA users from navigating anywhere but MFA checkpoint
    if (to.path !== '/mfa/checkpoint' && store.getters['Auth/mfaPending']) {
      log.debug('User is awaiting multi-factor authentication. Redirecting to checkpoint')
      return next({ path: '/mfa/checkpoint' })
    }

    // Prevent MFA enrollment users from navigating anywhere but MFA enrollment
    if (to.path !== '/mfa/enroll' && store.getters['Auth/mfaEnroll']) {
      log.debug('User is awaiting multi-factor enrollment. Redirecting to enrollment')
      return next({ path: '/mfa/enroll' })
    }

    // Don't let an authenticated user navigate to login.
    // If they do, redirect to the dashboard
    if (to.path === '/login' && store.getters['Auth/authenticated']) {
      log.debug('User is already logged in. Redirecting to dashboard')
      return next({ path: '/' })
    }

    // Is the user authenticated?
    if (to.meta.authRequired && !store.getters['Auth/authenticated']) {
      log.debug('Authentication required for this route. Redirecting to login')
      Message.closeAll()
      return next({ path: '/login', query: { redirect: to.path } })
    }

    // Check that a user has given permission before navigating
    if (to.meta.requiredPermission && !store.getters['Auth/hasPermission'](to.meta.requiredPermission)) {
      // TODO: Add a 404 page
      log.debug('Permission requirement not met for this route. Redirecting to dashboard home')
      return next({ path: '/not-authorized' })
    }

    // Redirect users who don't have dashboard access ('/')
    if (to.path === '/') {
      let redirect = from.query.redirect || undefined
      // Override the to path if it points to the dashboard
      if (redirect === '%2F' || redirect === '/') {
        redirect = undefined
      }

      // Redirect some roles to the CMS
      if (roleConstants.CMS_ROLE_REDIRECT === true) {
        const userRole = store.getters['Auth/user'].role
        const cmsUrl = process.env.CMS_WELCOME_URL
        if (roleConstants.CMS_ROLES.includes(userRole)) {
          window.location.replace(cmsUrl)
        }
      }

      // Advertiser users go to marketing dashboard
      if (store.getters['Auth/user'].roles.includes('Advertiser')) {
        log.debug('Advertising does not have dashboard access, redirecting to /marketing or redirect path')
        return next({ path: from.query.redirect || '/marketing' })
      }

      // Retailer Merchandiser users go to merchandise dashboard
      if ((store.getters['Auth/user'].roles.includes('Retailer')
        || store.getters['Auth/user'].roles.includes('Wholesaler'))
      && !store.getters['Auth/user'].roles.includes('Advertising')) {
      // eslint-disable-next-line max-len
        log.debug('Retail Merchandiser does not have dashboard access, redirecting to /merchandise or redirect path')
        return next({ path: from.query.redirect || '/merchandise' })
      }
      // Stockcheck admin goes to stores as audits are deprecated
      if (store.getters['Auth/user'].roles.includes('Stockcheck Admin')) {
        log.debug('Redirecting Stockcheck Admin to /issue-queue or redirect path')
        return next({ path: from.query.redirect || '/issue-queue' })
      }
      // IT admin goes to devices
      if (store.getters['Auth/user'].roles.length === 1 && store.getters['Auth/user'].roles.includes('IT')) {
        log.debug('Redirecting IT user to /devices or redirect path')
        return next({ path: from.query.redirect || '/devices' })
      }
      // Call Contractors go to call queue
      if (store.getters['Auth/user'].roles.includes('Call Contractor')) {
        log.debug('Redireting Call Contractor to /issue-queue')
        return next({ path: from.query.redirect || '/issue-queue' })
      }
      // Device Install Contractors and Network Health Contractors goes to stores
      if (store.getters['Auth/user'].roles.length === 1 &&
        (store.getters['Auth/user'].roles.includes('Device Install Contractor') ||
          store.getters['Auth/user'].roles.includes('Network Health Contractor'))) {
        log.debug('Redirecting Device Install Contractor to /stores or redirect path')
        return next({ path: from.query.redirect || '/stores' })
      }
    }

    return next()
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js